const state = {
	sidebar: 'opened',
	token: '',
	countries: [],
	cities: [],
	campaignPositions: [],
	campaignTypes: [],
	redirectionTypes: [],
	filterTypes: [],
	priceRanges: [],
	contactTypes: [],
	selectedBusinessId: null,
	selectedRestaurants: [],
	blockModes: [
		{ label: 'Normal', value: 1 },
		{ label: 'Auto', value: 0 },
	],
	loadingOrderId: null,
	isB2B: false,
	alert: { title: '' },
	closingReasonsGlobal: [],
	rejectReasonsGlobal: [],
	user: {
		restaurants: [],
	},
	posSettings: {},
};

export default state;
